import React, { useEffect, useState } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import MemberDetailsModal from "./MemberDetailModel";


const GroupCodeGenerator = () => {
  const db = getFirestore();
  const [groups, setGroups] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [groupDetails, setGroupDetails] = useState(null);
  const [generatedCode, setGeneratedCode] = useState([]);
  const [completed, setCompleted] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [allCodeBlock, setAllCodeBlock] = useState("");
  const [copied, setCopied] = useState(false)
  const [copiedIndex, setCopiedIndex] = useState(null);


  useEffect(() => {
    const fetchGroups = async () => {
      const snapshot = await getDocs(collection(db, "sevakGroups"));
      const groupList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setGroups(groupList);
    };
    fetchGroups();
  }, []);

  const fetchGroupDetails = () => {
    const selected = groups.find((group) => group.id === selectedGroupId);
    if (selected) {
      setGroupDetails(selected);
      setGeneratedCode([]);
    }
  };

  const generateCode = () => {
    if (!groupDetails?.members?.length) return;

    const snippets = groupDetails.members.map((row, index) => {
      return {
        index,
        name: row.sevakName,
        street: row.street,
        mobile: row.mobileNo,
        code: `
        (async () => {
          // Step 1: Click the camera icon to open file input
          const cameraIcon = document.querySelector(".profile_cameraIcon__jP9cI");
          if (cameraIcon) {
            cameraIcon.click();
          } else {
            console.error("Camera icon not found.");
            return;
          }
        
          // Step 2: Wait for file input and image upload
          const waitForImageUpload = () => {
            return new Promise((resolve) => {
              const check = () => {
                const input = document.querySelector('input[type="file"]');
                if (input && input.files.length > 0) {
                  resolve();
                } else {
                  setTimeout(check, 300);
                }
              };
              check();
            });
          };
          await waitForImageUpload();
        
          document.querySelectorAll('input[name="fitness"]').forEach((checkbox) => {
            if (!checkbox.checked) {
              checkbox.click(); // Simulates a real user click
            }
          });
        
          setTimeout(() => {
            const idNumberInput = document.getElementById("idNumber");
  const idNumber = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  idNumber.call(idNumberInput, "${row.AdharNumber}");
  idNumberInput.dispatchEvent(new Event('input', { bubbles: true }));

  const nameInput = document.getElementById("sevakName");
  const nameSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  nameSetter.call(nameInput, "${row.sevakName}");
  nameInput.dispatchEvent(new Event('input', { bubbles: true }));


  const surNameInput = document.getElementById("surName");
  const surNameSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  surNameSetter.call(surNameInput, "${row.surName}");
  surNameInput.dispatchEvent(new Event('input', { bubbles: true }));

  const fatherOrSpouseNameInput = document.getElementById("fatherOrSpouseName");
  const fatherOrSpouseNameSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  fatherOrSpouseNameSetter.call(fatherOrSpouseNameInput, "${row.fatherOrSpouseName}");
  fatherOrSpouseNameInput.dispatchEvent(new Event('input', { bubbles: true }));


  const dobInput = document.getElementById("dob");
  const dobSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  dobSetter.call(dobInput, "${row.dob}");
  dobInput.dispatchEvent(new Event('input', { bubbles: true }));

  const mobileNoInput = document.getElementById("mobileNo");
  const mobileNoSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  mobileNoSetter.call(mobileNoInput, "${row.mobileNo}");
  mobileNoInput.dispatchEvent(new Event('input', { bubbles: true }));


  const emailInput = document.getElementById("email");
  const emailSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  emailSetter.call(emailInput, "${row.email}");
  emailInput.dispatchEvent(new Event('input', { bubbles: true }));

  const genderInput = document.getElementById("gender");
  const genderSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  genderSetter.call(genderInput, "${row.gender}");
  genderInput.dispatchEvent(new Event('input', { bubbles: true }));

  const professionInput = document.getElementById("profession");
  const professionSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  professionSetter.call(professionInput, "${row.profession}");
  professionInput.dispatchEvent(new Event('input', { bubbles: true }));

   const countryInput = document.getElementById("country");
   const countrySetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
   countrySetter.call(countryInput, "${row.country}");
   countryInput.dispatchEvent(new Event('input', { bubbles: true }));

  const stateInput = document.getElementById("state");
  const stateSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  stateSetter.call(stateInput, "${row.state}");
  stateInput.dispatchEvent(new Event('input', { bubbles: true }));

  const districtInput = document.getElementById("district");
  const districtSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  districtSetter.call(districtInput, "${row.district}");
  districtInput.dispatchEvent(new Event('input', { bubbles: true }));

  const cityInput = document.getElementById("city");
  const citySetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  citySetter.call(cityInput, "${row.city}");
  cityInput.dispatchEvent(new Event('input', { bubbles: true }));

  const streetInput = document.getElementById("street");
  const streetSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  streetSetter.call(streetInput, "${row.street}");
  streetInput.dispatchEvent(new Event('input', { bubbles: true }));

  const doorNoInput = document.getElementById("doorNo");
  const doorNoSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  doorNoSetter.call(doorNoInput, "${row.doorNo}");
  doorNoInput.dispatchEvent(new Event('input', { bubbles: true }));

  const pincodeInput = document.getElementById("pincode");
  const pincodeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  pincodeSetter.call(pincodeInput, "${row.pincode}");
  pincodeInput.dispatchEvent(new Event('input', { bubbles: true }));

  const nearestTtdTempleInput = document.getElementById("nearestTtdTemple");
  const nearestTtdTempleInputSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  nearestTtdTempleInputSetter.call(nearestTtdTempleInput, "${row.nearestTtdTemple}");
  nearestTtdTempleInput.dispatchEvent(new Event('input', { bubbles: true }));
        
            setTimeout(() => {
              const addButton = document.querySelector(".profile_addBtn__oA2Q1");
              if (addButton) {
                addButton.click();
                console.log("✅ Add button clicked after image and form completion.");
              } else {
                console.error("Add button not found.");
              }
            }, 500);
          }, 500);
        })();        
`.trim(),
      };
    });

    setGeneratedCode(snippets);
  };

  const generateCombinedScript = () => {
    const memberFunctions = generatedCode
      .map((row, idx) => {
        return `
async function member${idx + 1}() {
  return new Promise((resolve) => {
    ${row.code}
    setTimeout(resolve, 3000);
  });
}`.trim();
      })
      .join("\n\n");

    const runner = `
(async () => {
  ${generatedCode.map((_, idx) => `await member${idx + 1}();`).join("\n  ")}
})();
`.trim();

    setAllCodeBlock(`${memberFunctions}\n\n${runner}`);
  };

  const handleCopy = (index) => {
    navigator.clipboard.writeText(generatedCode[index].code).then(() => {
      setCopiedIndex(index); // Only one index is marked as copied at a time
    });
  };





  const handleComplete = (index) => {
    setCompleted((prev) => ({ ...prev, [index]: true }));
  };

  const handlePending = (index) => {
    setCompleted((prev) => ({ ...prev, [index]: false }));
  };


  const handleCopyPath = () => {
    navigator.clipboard.writeText(groupDetails.imageFolderPath).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Hide message after 2 seconds
    });
  };

  const handleCopyAllCode = () => {
    navigator.clipboard.writeText(allCodeBlock).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Hide message after 2 seconds
    });
  };



  const handleMemberClick = (member) => {
    setSelectedMember(member);
    setShowModal(true);
  };

  return (
    <div className="container mt-4">
      <h3>Select Group</h3>
      <select
        className="form-select"
        value={selectedGroupId}
        onChange={(e) => setSelectedGroupId(e.target.value)}
      >
        <option value="">-- Select Group --</option>
        {groups.map((group) => (
          <option key={group.id} value={group.id}>
            {group.groupName}
          </option>
        ))}
      </select>

      <button className="btn btn-primary mt-2" onClick={fetchGroupDetails}>
        Fetch Details
      </button>

      {groupDetails && (
        <>
          <h5 className="mt-4">Members Details</h5>
          <p><strong style={{ marginRight: "7px" }}>Image Folder:</strong>{groupDetails.imageFolderPath}
            <span><button className="btn btn-sm btn-secondary ms-2" onClick={handleCopyPath}>
              Copy
            </button>{copied && <span style={{ marginLeft: "10px", color: "green" }}>Copied!</span>}
            </span></p>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Street</th>
                <th>Mobile</th>
              </tr>
            </thead>
            <tbody>
              {groupDetails.members.map((member, idx) => (
                <tr
                  key={idx}
                  onClick={() => handleMemberClick(member)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{idx + 1}</td>
                  <td>{member.sevakName}</td>
                  <td>{member.street}</td>
                  <td>{member.mobileNo}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <MemberDetailsModal
            show={showModal}
            onHide={() => setShowModal(false)}
            member={selectedMember}
          />

          <button className="btn btn-success mt-3 mb-3" onClick={generateCode}>
            Convert to Code
          </button>
        </>
      )
      }

      {
        generatedCode.length > 0 && (
          <>
            <h5>Generated Code</h5>
            <p><strong style={{ marginRight: "7px" }}>Image Folder:</strong>{groupDetails.imageFolderPath}
              <span><button className="btn btn-sm btn-secondary ms-2" onClick={handleCopyPath}>
                Copy
              </button>{copied && <span style={{ marginLeft: "10px", color: "green" }}>Copied!</span>}
              </span></p>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Street</th>
                  <th>Mobile</th>
                  <th>Copy</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {generatedCode.map((row, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{row.name}</td>
                    <td>{row.street}</td>
                    <td>{row.mobile}</td>
                    <td style={{ position: "relative", paddingRight: "60px", whiteSpace: "nowrap" }}>
                      <div style={{ display: "inline-block", position: "relative" }}>
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => handleCopy(idx)}
                        >
                          📋 Copy
                        </button>

                        {copiedIndex === idx && (
                          <span
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "100%",
                              transform: "translateY(-50%)",
                              marginLeft: "8px",
                              fontSize: "0.75rem",
                              color: "green",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Copied!
                          </span>
                        )}
                      </div>
                    </td>
                    <td>
                      {!completed[row.index] ? (
                        <>
                          <button
                            className="btn btn-sm btn-primary me-1"
                            onClick={() => handleComplete(row.index)}
                          >
                            ✅ Complete
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handlePending(row.index)}
                          >
                            ⏳ Pending
                          </button>
                        </>
                      ) : (
                        <button className="btn btn-sm btn-secondary" disabled>
                          ✅ Completed
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button className="btn btn-warning mt-3 mb-3" onClick={generateCombinedScript}>
              ⚙️ Convert All & Auto Add
            </button>
          </>
        )
      }

      {
        allCodeBlock && (
          <div className="mt-3">
            <div className="d-flex flex-row">
              <h5 className="mt-2 ms-2">Combined Auto Script</h5>
              <button
                className="btn btn-outline-primary ms-3 mb-1"
                onClick={handleCopyAllCode}
              >
                📋 Copy Script
              </button>
              {copied && <span class="ms-2 mt-2 text-success">Copied!</span>}
            </div>
            <textarea className="form-control" rows={20} value={allCodeBlock} readOnly />
            <button
              className="btn btn-outline-primary ms-3 mb-1"
              onClick={handleCopyAllCode}
            >
              📋 Copy Script
            </button>
            {copied && <span class="ms-2 mt-2 text-success">Copied!</span>}
          </div>
        )
      }
    </div >
  );
};

export default GroupCodeGenerator;
